import { META_APP_VERSION_KEY, META_SCHEMA_KEY, STORAGE_SCHEMA_VERSION } from '@texas42/app-model';
import type { Texas42Database } from './db.js';
import { APP_VERSION, STORE_META } from './constants.js';
import { computeChecksum } from './checksum.js';

export async function writeDatabaseMetadata(db: Texas42Database): Promise<void> {
  await db.put(STORE_META, {
    key: META_SCHEMA_KEY,
    value: STORAGE_SCHEMA_VERSION,
    checksum: await computeChecksum(STORAGE_SCHEMA_VERSION),
  });
  await db.put(STORE_META, {
    key: META_APP_VERSION_KEY,
    value: APP_VERSION,
    checksum: await computeChecksum(APP_VERSION),
  });
}
